// extracted by mini-css-extract-plugin
export var container = "_cj-0";
export var infoIcon = "_cj-2";
export var titleRowCol = "_cj-1";